import { UtpCardStructure } from 'common/components';
import { CONSTRUCTION_HOUSES_CDN_PATH } from 'landings/construction-houses/construction-houses-constants';
import { ForBusiness, ForPrivate, ForProfi } from './components';

export const CONSTRUCTION_HOUSES_UTP_CARD_LIST: UtpCardStructure<Record<string, never>>[] = [
  {
    elementName: 'Для бизнеса',
    header: {
      title: 'Для бизнеса',
    },
    description: {
      text: '',
      mobileText: '',
    },
    image: {
      alt: 'Бизнесмен',
      src: `${CONSTRUCTION_HOUSES_CDN_PATH}/utp/dlya-biznesa.png/dlya-biznesa.png`,
    },
    modal: { content: ForBusiness },
  },
  {
    elementName: 'Для профессионалов',
    header: {
      title: 'Для профессионалов',
    },
    description: {
      text: '',
      mobileText: '',
    },
    image: {
      alt: 'Профессионал',
      src: `${CONSTRUCTION_HOUSES_CDN_PATH}/utp/dlya-professionalov.png/dlya-professionalov.png`,
    },
    modal: { content: ForProfi },
  },
  {
    elementName: 'Для частных клиентов',
    header: {
      title: 'Для частных клиентов',
    },
    description: {
      text: '',
      mobileText: '',
    },
    image: {
      alt: 'Частные клиенты',
      src: `${CONSTRUCTION_HOUSES_CDN_PATH}/utp/dlya-chastnyh-klientov.png/dlya-chastnyh-klientov.png`,
    },
    modal: { content: ForPrivate },
  },
];
